import { useEffect, useState } from 'react'

// Subscribes to `packages:checklist:update` CustomEvents dispatched on the root node
// identified by the given ref. Event payload: `{ id, complete }`.
// Root node carries id="submit-application-package" so existing jQuery flows
// (lock-all, fee-authorize, PDF generator) can dispatch into it without importing React.
export function useChecklistState(rootRef, initialItems) {
  const [items, setItems] = useState(initialItems || [])

  useEffect(() => {
    const node = rootRef && rootRef.current
    if (!node) return undefined

    const onUpdate = (event) => {
      const { id, complete } = event.detail || {}
      if (!id) return
      setItems((prev) => prev.map((item) => (item.id === id ? { ...item, complete } : item)))
    }

    node.addEventListener('packages:checklist:update', onUpdate)
    return () => node.removeEventListener('packages:checklist:update', onUpdate)
  }, [rootRef])

  return items
}
